export function changeMotifTheme(motifThemes, action) {
  return function (dispatch) {
    dispatch({ type: action, motifThemes });
  };
}
